import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";


export class SmartCollectLedger {
    constructor(ledgerObject = {}) {
        this.set(ledgerObject);
    };

    static validations = {
        "id": [],
        "uuid": [],
        "created_at": [],
    };

    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/ledger/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/insta-collect/internal/ledger/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    static report_download = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/insta-collect/internal/ledger/report_download/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    retreive = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/ledger/${this.uuid}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Ledger
     * @type Setter Method
     * @takes Ledger Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}